import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { viewerApi, ViewerOrganizationsResponse } from 'app/services/edpApiV1/viewer';

type Organizations = [{ id: string | null; name: string | null }];

const initialState: { organizations: Organizations; allAvailableOrganizations: boolean } = {
  organizations: [{ id: null, name: null }],
  allAvailableOrganizations: false,
};

export const organizationsSlice = createSlice({
  name: 'viewer/me/organizations',
  initialState,
  reducers: {
    setAllOrganizations: (state, { payload }: PayloadAction<boolean>) => {
      state.allAvailableOrganizations = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(
        viewerApi.endpoints.organizations.matchFulfilled,
        (state, { payload }: PayloadAction<ViewerOrganizationsResponse>) => {
          state.organizations = payload;
        },
      )
      .addMatcher(viewerApi.endpoints.organizations.matchRejected, () => initialState);
  },
});

const organizations = (state: RootState) => state.entities.organizations;
export const getOrganizations = createSelector(organizations, state => state);
export const getAllAvailableOrganizations = createSelector(
  organizations,
  state => state.organizations.allAvailableOrganizations,
);

export const selectors = { getOrganizations };
export const organizationsActions = organizationsSlice.actions;
export const reducer = organizationsSlice.reducer;
